<script setup lang="ts">
import CompletionFlowIcon from '@/assets/icons/counterparty/master/completion-flow.svg?skipsvgo';

const { play = false } = defineProps<{ play?: boolean }>();
</script>

<template>
  <CompletionFlowIcon
    v-if="play"
    class="completion-icon"
  />
</template>
